import { Button } from "@ariakit/react";
import { counter } from "./style.css.ts";

export function Counter(props: {
  count: number;
  onIncrement: () => void;
  onDecrement: () => void;
}) {
  const { count, onIncrement, onDecrement } = props;

  return (
    <div className={counter.container}>
      <Button
        className={counter.button}
        onClick={onDecrement}
        disabled={count === 1}
      >
        -
      </Button>

      <span className={counter.count}>{count}</span>

      <Button className={counter.button} onClick={onIncrement}>
        +
      </Button>
    </div>
  );
}
